import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FSATableModel, ProceduresModel, updateTemplateIdModel, UserDetailModel } from 'countable@model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { EncodingService } from './encoding.service';

const textResponse: any = { responseType: 'text' };

@Injectable({
  providedIn: 'root'
})
export class WorksheetService {

  WorksheetFolderData: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  refreshWorksheetData: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  AddFirmTemplateDialog: Subject<any> = new Subject<any>();
  WorksheetSearchSub: Subject<any> = new Subject<any>();
  copyWorksheetTemplate: Subject<any> = new Subject<any>();
  duplicateWorksheetTemplate: Subject<any> = new Subject<any>();
  deleteWorksheetTemplate: Subject<any> = new Subject<any>();
  cancelWorksheetTemplate: Subject<any> = new Subject<any>();
  delWorkSheetDoc: Subject<any> = new Subject<any>();
  WSTemplateDuplicate: Subject<any> = new Subject<any>();
  DeleteWSTemplate: Subject<any> = new Subject<any>();
  WSrenameTemplatename: Subject<any> = new Subject<any>();
  updateTemplateJSON: Subject<any> = new Subject<any>();
  saveLeftDocWorksheet: Subject<any> = new Subject<any>();
  saveLeftDocProcedure: Subject<any> = new Subject<any>();
  refreshMiddle: Subject<any> = new Subject<any>();
  deleteLeftOnMiddleDelete: Subject<any> = new Subject<any>();
  ESRef: Subject<any> = new Subject<any>();
  ProcedureRef: Subject<any> = new Subject<any>();
  worksheetselectedTemplatecount: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  LSNameList : BehaviorSubject<any> = new BehaviorSubject<any>(null);
  updateRenameDocument: Subject<any> = new Subject<any>();

  readonly proceduresMasterFirm$: BehaviorSubject<ProceduresModel> = new BehaviorSubject<ProceduresModel>(null);
  originalMappedProcedures$: BehaviorSubject<FSATableModel[]> = new BehaviorSubject<FSATableModel[]>(null);
  updatedMappedProcedures$: BehaviorSubject<FSATableModel[]> = new BehaviorSubject<FSATableModel[]>(null);
  updateEntriesAfterModification: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  refreshTemplateName: Subject<updateTemplateIdModel> = new Subject<updateTemplateIdModel>();
  constructor(private httpClient: HttpClient, handler: HttpBackend, private authService: AuthService, private encodingService: EncodingService) { }

  getUserDetails(): UserDetailModel | null {
    return JSON.parse((localStorage.getItem('userDetails')));
  }

  getUserDetail() {
    return this.authService.getUserDetail();
  }

  getUserId(): number {
    return this.getUserDetails().useracctid;
  }

  getFirmId(): number {
    return this.getUserDetails().firmUserAcctId;
  }

  getS3FilePath(): string {
    return 'Engagements/' + this.getFirmId() + '_Firm/Templates/worksheet';
  }

  getMasterFolderPath(): string {
    return 'Engagements/masterTemplate/worksheet';
  }

  getWorksheetFolderNames(templatesData) {
    return templatesData.map(folder => folder.foldername.toLocaleLowerCase());
  }

  getWorksheetTemplateNames(templatesData) {
    return templatesData.map(folder => folder.templates && folder.templates.map(file => file.TemplateName.toLocaleLowerCase())).flat(Infinity);
  }
  getEngagementDetails() {
    return JSON.parse((localStorage.getItem('selectedEngagementObj')));
  }
  getClientFirmId(): number {
    return this.getEngagementDetails().clientfirmid;
  }
  getFormDataS3(s3FileName: string, finalSaveContent): FormData {
    const jsonString = JSON.stringify(finalSaveContent);
    const blob = new Blob([jsonString], { type: 'text/json;charset=utf-8' });
    const formS3Data: FormData = new FormData();
    const uploadObj = JSON.stringify({
      module: "Worksheets: Firm Template",
      firmId: this.getFirmId(),
      status: 0,
      folderName: "null",
      appSyncId: this.getUserId(),
      extension: "comp",
    });
    formS3Data.append('upload', this.encodingService.enData(uploadObj, 'body'));
    formS3Data.append('file', blob, s3FileName);
    return formS3Data;
  }
  getFormDataS3InsideEngagement(filePath: string, s3FileName: string, finalSaveContent): FormData {
    const jsonString = JSON.stringify(finalSaveContent);
    const blob = new Blob([jsonString], { type: 'text/json;charset=utf-8' });
    const formS3Data: FormData = new FormData();
    const uploadObj = JSON.stringify({
      "module": "Inside ENG Worksheets",
      "firmId": this.getFirmId(),
      "clientId": this.getClientFirmId(),
      "status": 0,
      "folderName": null,
      "extension": 'comp',
      "appSyncId": this.getUserId(),
      "engagementId": this.getEngagementDetails().engagementsid,
      "signatureKey": filePath,
      "fileName": s3FileName
    });
    formS3Data.append('upload', this.encodingService.enData(uploadObj, 'body'));
    formS3Data.append('file', blob, s3FileName);
    return formS3Data;
  }
  getReviewTemplate(loginId: number): Observable<any> {
    const path = environment.apiV1 + '/' + encodeURIComponent(this.encodingService.enData(loginId)) + '/review/template';
    return this.httpClient.get(path, textResponse);
  }

  BLANK_TEMPLATE = [
    {
      "parent": [
        {
          "childern": [
            {
              "section": "",
              "category": "",
              "moduleid": 0,
              "submoduleid": 0,
              "newsubmodule_smufid": ""
            }
          ],
          "moduleid": 0,
          "modulename": "Add Folder",
          "submoduleid": 0,
          "submodulename": "",
          "newsubmodule_smufid": ""
        },
        {
          "childern": [
            {
              "section": "Signoffs",
              "category": "Module",
              "moduleid": 5,
              "submoduleid": 108,
              "newsubmodule_smufid": "2f210e74-00d"
            }
          ],
          "moduleid": 5,
          "modulename": "Module",
          "submoduleid": 108,
          "submodulename": "Signoffs",
          "newsubmodule_smufid": "2f210e74-00d"
        }
      ]
    }
  ]

  getTemplateNamesInFolder(templates: any[]) {
    return templates.map(template => template.TemplateName.toLocaleLowerCase());
  }

  setMappedProcedures(s3ESData: any, typeOfAction: 'original' | 'updated') {
    switch (typeOfAction) {
      case 'original':
        const parsedData = JSON.parse(s3ESData);
        if (!parsedData) break;
        const fsa = parsedData["FSA"] ? parsedData["FSA"] : []
        if (fsa && fsa.length === 0) break;
        const proceduresList: Array<FSATableModel> | null = fsa[1]["data"] ?? [];
        if (!proceduresList) break;
        this.originalMappedProcedures$.next(proceduresList);
        break;
      case 'updated':
        const updatedFSA = s3ESData["FSA"] ? s3ESData["FSA"] : [];
        if (updatedFSA && updatedFSA.length === 0) break;
        const updatedProceduresList: Array<FSATableModel> | null = updatedFSA[1]["data"] ?? [];
        if (updatedProceduresList && updatedProceduresList.length === 0) {
          this.updatedMappedProcedures$.next([]);
          return;
        }
        this.updatedMappedProcedures$.next(updatedProceduresList);
      // typeOfAction === 'updated' && this.updatedMappedProcedures$.next()
    }
  }

  fetchUpdatedMapping(originalFSAMapData: FSATableModel[], ChangedFSAMapData: FSATableModel[]) {
    return ChangedFSAMapData.filter((changedMapObj: FSATableModel) => !this.findSameMappings(changedMapObj,
      originalFSAMapData.find(o => o.leadsheetid === changedMapObj.leadsheetid)))
  }

  private findSameMappings(ChangedFSAMapObj: FSATableModel, originalFSAMapObj: FSATableModel): boolean {
    if (!originalFSAMapObj) return false
    return ((originalFSAMapObj && ChangedFSAMapObj) && (originalFSAMapObj.JsonFilePath === ChangedFSAMapObj.JsonFilePath)) &&
      ((originalFSAMapObj && ChangedFSAMapObj) && (originalFSAMapObj.master_template_uid === ChangedFSAMapObj.master_template_uid))
  }

  setS3PathForProcedures(fileName: string) {
    if (fileName === '') return '';
    return 'Engagements/' + this.getUserDetail().firmUserAcctId + '_Firm/' + this.getEngagementDetails().clientfirmid + '_Client/' + this.getEngagementDetails().engagementsid
      + '_Engagements/EngagementDocs/Worksheet/' + fileName
  }

  fetchDeletedMappings(originalFSAMapData: FSATableModel[], changedFSAMapData: FSATableModel[]) {
    return originalFSAMapData.filter((originalRow: FSATableModel) => {
      const updatedRow = changedFSAMapData.find((updatedObj: FSATableModel) => updatedObj.leadsheetid === originalRow.leadsheetid);
      return ((originalRow.JsonFilePath !== '' && updatedRow.JsonFilePath === '') && (originalRow.master_template_uid !== '' && updatedRow.master_template_uid === ''))
    })
  }

  getProceduresDataS3InsideEng(s3FileName: string, finalSaveContent): FormData {
    const jsonString = JSON.stringify(finalSaveContent);
    const blob = new Blob([jsonString], { type: 'text/json;charset=utf-8' });
    const formS3Data: FormData = new FormData();
    let selectedEngagement = JSON.parse((localStorage.getItem('selectedEngagementObj')));

    const uploadObj = JSON.stringify({
      module: "Inside ENG Worksheets",
      firmId: this.getFirmId(),
      status: 0,
      clientId: selectedEngagement.clientfirmid,
      engagementId: selectedEngagement.engagementsid,
      folderName: "null",
      appSyncId: this.getUserId(),
      extension: "comp",
    });
    formS3Data.append('upload', this.encodingService.enData(uploadObj, 'body'));
    formS3Data.append('file', blob, s3FileName);
    return formS3Data;
  }

  fetchUpdatedMMLProcedures(originalFSAMapData: FSATableModel[], changedFSAMapData: FSATableModel[], changedRows: number[]) {
    const changedRowData: FSATableModel[] = JSON.parse(JSON.stringify(changedFSAMapData));
    const removeUpdatedMapRows = changedRowData.filter((row: FSATableModel) => !changedRows.includes(row.leadsheetid));
    const removeUnMappedRows: FSATableModel[] = removeUpdatedMapRows.filter((row: FSATableModel) => row.JsonFilePath !== '' && row.master_template_uid !== '');
    const getOnlyMMLChangedData = removeUnMappedRows.filter((updatedRow: FSATableModel) => {
      const originalRowObj: FSATableModel = originalFSAMapData.find((originalRow: FSATableModel) => originalRow.leadsheetid === updatedRow.leadsheetid)
      return (originalRowObj && (originalRowObj.materialityML !== updatedRow.materialityML));
    });
    return getOnlyMMLChangedData;
  }

}
